import update from 'immutability-helper';

export const stores = (state = {
    'items'  : false,
}, action) => {
    switch (action.type) {
		case 'MERGE-STORES-STATES':
			state = update(state, {$merge: action.payload});
		break;

        default:
            return state;
    }

    return state;
};
